import { c as _c } from "react/compiler-runtime";
import EditActionWrapper, { ACCESSIBLE_LABEL_REQUIRED_CLASSNAME, ACCESSIBLE_LABEL_ROW_CLASSNAME } from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { ActionEmailEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import CreateEmailFlow from 'modules/automation-rules/email/components/create-email-flow';
import EditEmailFlow from 'modules/automation-rules/email/components/edit-email-flow';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import React from 'react';
import { FormSelect } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ActionEmailItemProps extends EditActionItemInterface<ActionEmailEditInterface> {}
const ActionEmailItem = t0 => {
  const $ = _c(15);
  const {
    actions,
    setRules,
    errors,
    idx,
    action,
    onDelete
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== action.id || $[4] !== action.systemeEmail || $[5] !== actions || $[6] !== errors.automationActions || $[7] !== idx || $[8] !== setRules || $[9] !== t) {
    t2 = t3 => {
      const {
        data,
        onOpen
      } = t3;
      return <div className="flex flex-col gap-2"><div className={ACCESSIBLE_LABEL_ROW_CLASSNAME}><span className={ACCESSIBLE_LABEL_REQUIRED_CLASSNAME} data-required={true}>{t("global.email")}</span><span className="flex h-5 items-center gap-1.5 [&_svg]:size-4 [&_svg]:shrink-0"><CreateEmailFlow onSetNewEmail={data_0 => setRules(prev => ({
              ...prev,
              actions: actions.map((el, i) => {
                if (idx === i) {
                  return {
                    ...el,
                    systemeEmail: data_0
                  };
                } else {
                  return el;
                }
              })
            }))} mutateSpecificEmailData={data.mutateSpecificEmailData} mutateEmailData={data.mutateEmailData} />{action.systemeEmail.id && <EditEmailFlow mutateSpecificEmailData={data.mutateSpecificEmailData} mutateEmailData={data.mutateEmailData} emailId={action.systemeEmail.id} onSetNewEmail={data_1 => setRules(prev_0 => ({
              ...prev_0,
              actions: actions.map((el_0, i_0) => {
                if (idx === i_0) {
                  return {
                    ...el_0,
                    systemeEmail: data_1
                  };
                } else {
                  return el_0;
                }
              })
            }))} />}</span></div><FormSelect ariaLabel={t("global.email")} onOpen={onOpen} placeholder={t("dashboard.automation_rule.choose_email")} required={true} value={action.systemeEmail.id} staticData={getDataFromObj({
          id: action.systemeEmail.id,
          name: action.systemeEmail.subject
        })} data={data.emailData} onChange={data_2 => setRules(prev_1 => ({
          ...prev_1,
          actions: actions.map((el_1, i_1) => {
            if (idx === i_1) {
              return {
                ...el_1,
                systemeEmail: {
                  ...action.systemeEmail,
                  id: data_2
                }
              };
            } else {
              return el_1;
            }
          })
        }))} error={errors.automationActions[action.id]?.systemeEmail?.join("")} /></div>;
    };
    $[3] = action.id;
    $[4] = action.systemeEmail;
    $[5] = actions;
    $[6] = errors.automationActions;
    $[7] = idx;
    $[8] = setRules;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== action.type || $[12] !== t1 || $[13] !== t2) {
    t3 = <EditActionWrapper slug={action.type} onDelete={t1}>{t2}</EditActionWrapper>;
    $[11] = action.type;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default ActionEmailItem;